@defer () {
  <h1 class="pb-2">{{ productData?.translations[currentLanguage].title }}</h1>
  <app-page-list></app-page-list>
}


<router-outlet></router-outlet>

